module.exports = __webpack_public_path__ + "static/stork-infographics-5584d66813d2effc7f06f9c191ab4ef6.png";